import { render, staticRenderFns } from "./VideoSelectorStep.vue?vue&type=template&id=6e8ed1eb"
import script from "./VideoSelectorStep.vue?vue&type=script&lang=js"
export * from "./VideoSelectorStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports